import { StatusTransitionModel } from '@abb-procure/data';
import {
  afterNextRender,
  Component,
  Input,
  OnChanges,
  OnInit,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { DatePipe } from '../../pipes/date.pipe';
import { NgChanges } from '../../utilities/angular-types.util';
import { StatusBadge } from '../status-badge/status-badge.component';
import { Table } from '../table/table.component';

@Component({
  selector: 'procure-entity-log',
  templateUrl: './entity-log.component.html',
  styleUrl: './entity-log.component.scss',
  imports: [
    MatTable,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderCellDef,
    MatCell,
    MatRow,
    MatCellDef,
    MatColumnDef,
    MatNoDataRow,
    MatRowDef,
    MatHeaderRowDef,
    StatusBadge,
    DatePipe,
    Table,
    MatSort,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EntityLog implements OnInit, OnChanges {
  @Input() transitions: readonly StatusTransitionModel[] = [];

  readonly table = viewChild.required(Table);
  readonly sort = viewChild.required(MatSort);

  readonly displayedColumns: readonly string[] = [
    'fromState',
    'toState',
    'responsible',
    'date',
  ];

  protected dataSource: MatTableDataSource<StatusTransitionModel> =
    new MatTableDataSource([]);

  protected dataSourceTotalLength = 0;

  constructor() {
    this.dataSource.sortData = (
      data: StatusTransitionModel[],
      sort: MatSort,
    ): StatusTransitionModel[] => {
      if (!sort.active || sort.direction === '') {
        return data;
      }

      return data.sort((a, b) => {
        let result: number;

        switch (sort.active) {
          case 'fromState':
            result = a.previousStatus.name.localeCompare(b.previousStatus.name);
            break;
          case 'toState':
            result = a.nextStatus.name.localeCompare(b.nextStatus.name);
            break;
          case 'responsible':
            if (a.responsible && b.responsible) {
              result = a.responsible.localeCompare(b.responsible);
            } else {
              result = a.responsible ? 1 : -1;
            }

            break;
          default:
            result = a.date.getTime() - b.date.getTime();
        }

        return result * (sort.direction === 'asc' ? 1 : -1);
      });
    };

    afterNextRender(() => {
      this.dataSource.paginator = this.table().paginator();
      this.dataSource.sort = this.sort();
    });
  }

  ngOnInit(): void {
    this.table().paginator().pageSize = 10;
  }

  ngOnChanges(changes: NgChanges<EntityLog>): void {
    if (
      'transitions' in changes &&
      changes.transitions.previousValue !== changes.transitions.currentValue
    ) {
      this.updateDataSource();
    }
  }

  private updateDataSource(): void {
    this.dataSource.data = [...this.transitions];
    this.dataSourceTotalLength = this.transitions.length;
  }
}
